import React from 'react'
// import Navbar from '../component/Navbar/Navbar'
// import Navbar2 from '../component/Navbar2'
import Footer from '../component/Footer/Footer';

function LeadershipAudioResource() {
  return (
    <div>
           {/* <Navbar2/> */}

<nav className="word-coc-blog">
    <audio className='audiop' controls style={{width: '90%', backgroundColor: '#474544'}}></audio>
    <a href="#" class="btn btn-primary"> <svg xmlns="http://www.w3.org/2000/svg" width="2.75em" height="2.75em" fill="currentColor" class="bi bi-cloud-download-fill" viewBox="0 0 16 16" style={{color:'#001355'}}>
  <path fill-rule="evenodd" d="M8 0a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 4.095 0 5.555 0 7.318 0 9.366 1.708 11 3.781 11H7.5V5.5a.5.5 0 0 1 1 0V11h4.188C14.502 11 16 9.57 16 7.773c0-1.636-1.242-2.969-2.834-3.194C12.923 1.999 10.69 0 8 0zm-.354 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V11h-1v3.293l-2.146-2.147a.5.5 0 0 0-.708.708l3 3z"/>
</svg> Go somewhere</a>
  </nav>  

<main>
  <br/>
  <br/>
 <br/>
 <br/>
 <br/>
 
    <br></br>
    <div className="card-body">
        <small>Feb 20, 2023</small>
        <br></br>
        <h1 className="card-title ">Becoming like Jesus</h1> <br></br>
        <h4><b>Bringing yourself down to earth to following Jesus</b></h4><br></br>
        
        <p className="card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum, dignissimos quisquam enim repellat assumenda dolor exercitationem nulla officia ducimus distinctio dolores suscipit ea animi molestiae. Recusandae totam ut ipsum non?</p>
    </div>
    <br/>
  <br/>
 <br/>
 <br/>
 <br/>
</main>

<Footer/>
</div>

  )
}

export default LeadershipAudioResource;